export const environment = {
  production: true,
  base_url: 'https://api.tradenetlease.com/api',
  brokerRoleName: "B+E Broker",
  intercom_api: '',
  //intercom_api: 'vfdtgib4',
  propertyGuid: '70cc63c5-1c4c-464f-83fc-af9d7bc6f3cb',
  share_url: 'https://share.tradenetlease.com',
  video_name: 'B+E_H264.mov',
  siteurl: 'https://portal.tradenetlease.com',
  WPsiteurl: 'https://tradenetlease.com/',
  auth0: {
    domain: 'login.tradenetlease.com',
    tenant: 'benetlease-dev',
    customdomain: 'login.tradenetlease.com',
    configurationBaseUrl: 'https://cdn.auth0.com/',

    clientId: 'tRgmsua76vEvyYbGINLYsxUHqxkxaIz0',
    callbackURL: 'https://portal.tradenetlease.com',
    connection: "BE-Production",

    url: 'https://login.tradenetlease.com/',
    tokenRefreshTime: 0,
    redirect: false,
    defaultPassword: "Abcd@123"
  },

  auth0API: {
    client_id: 'yNsJSEIFfT9M7oFByslzfJPDIYnvY2d5',
    client_secret: 'IFLpDCjsZ7ghopJCsBhgQADxXx1h1LVQNHwYzkBumCJnbKsBi4dQ1LX3beVQuiUF',
    grant_type: 'client_credentials',
    url: 'https://benetlease-dev.auth0.com/'
  },
  jwtTokenExpiry: 3,
  importExcelPath: 'https://be-prd.s3.amazonaws.com/BE/ImportTemplateUAT',
  stockNewsAPIToken: 'd9sry2skkb8zamv12vclrzsibrpkydzx2l84ulat',
  rapidapihost: 'apidojo-yahoo-finance-v1.p.rapidapi.com',
  rapidapikey: '05e6dcddd4msha967cba4b6adfeap1093d3jsn4a824503bfa1'
};
